"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get APPOINTMENT_CANCELLATION_REASON_LABELS () {
        return _appointmentcancellation.APPOINTMENT_CANCELLATION_REASON_LABELS;
    },
    get APPOINTMENT_INVALID_TRANSITION () {
        return _appointmenterrors.APPOINTMENT_INVALID_TRANSITION;
    },
    get APPOINTMENT_NOT_RESCHEDULABLE () {
        return _appointmenterrors.APPOINTMENT_NOT_RESCHEDULABLE;
    },
    get APPOINTMENT_STATUS_CONFLICT () {
        return _appointmenterrors.APPOINTMENT_STATUS_CONFLICT;
    },
    get APPOINTMENT_STATUS_LABELS () {
        return _appointmentstatus.APPOINTMENT_STATUS_LABELS;
    },
    get APPOINTMENT_STATUS_TRANSITIONS () {
        return _appointmentstatus.APPOINTMENT_STATUS_TRANSITIONS;
    },
    get APPOINTMENT_UPDATE_CONFLICT () {
        return _appointmenterrors.APPOINTMENT_UPDATE_CONFLICT;
    },
    get AppointmentCancellationItemSchema () {
        return _appointmentcancellation.AppointmentCancellationItemSchema;
    },
    get AppointmentCancellationReasonSchema () {
        return _appointmentcancellation.AppointmentCancellationReasonSchema;
    },
    get AppointmentCancellationSchema () {
        return _appointmentcancellation.AppointmentCancellationSchema;
    },
    get AppointmentCreateRequestSchema () {
        return _appointmentcreate.AppointmentCreateRequestSchema;
    },
    get AppointmentCreateResponseSchema () {
        return _appointmentcreate.AppointmentCreateResponseSchema;
    },
    get AppointmentListCountsSchema () {
        return _appointmentlist.AppointmentListCountsSchema;
    },
    get AppointmentListItemSchema () {
        return _appointmentlist.AppointmentListItemSchema;
    },
    get AppointmentListQuerySchema () {
        return _appointmentlist.AppointmentListQuerySchema;
    },
    get AppointmentListResponseSchema () {
        return _appointmentlist.AppointmentListResponseSchema;
    },
    get AppointmentRescheduleRequestSchema () {
        return _appointmentreschedule.AppointmentRescheduleRequestSchema;
    },
    get AppointmentRescheduleResponseSchema () {
        return _appointmentreschedule.AppointmentRescheduleResponseSchema;
    },
    get AppointmentStatusChangeRequestSchema () {
        return _appointmentstatuschange.AppointmentStatusChangeRequestSchema;
    },
    get AppointmentStatusChangeResponseSchema () {
        return _appointmentstatuschange.AppointmentStatusChangeResponseSchema;
    },
    get AppointmentStatusSchema () {
        return _appointmentstatus.AppointmentStatusSchema;
    },
    get ProviderListItemSchema () {
        return _appointmentproviders.ProviderListItemSchema;
    },
    get ProviderListResponseSchema () {
        return _appointmentproviders.ProviderListResponseSchema;
    },
    get VISIT_TYPE_LABELS () {
        return _visittype.VISIT_TYPE_LABELS;
    },
    get VisitTypeSchema () {
        return _visittype.VisitTypeSchema;
    },
    get canTransition () {
        return _appointmentstatus.canTransition;
    }
});
const _appointmentstatus = require("./appointment-status");
const _visittype = require("./visit-type");
const _appointmentlist = require("./appointment-list");
const _appointmentproviders = require("./appointment-providers");
const _appointmentcreate = require("./appointment-create");
const _appointmentcancellation = require("./appointment-cancellation");
const _appointmentstatuschange = require("./appointment-status-change");
const _appointmentreschedule = require("./appointment-reschedule");
const _appointmenterrors = require("./appointment-errors");
